export const CaCartType = [
  'group',
  'individual'
];
